import type {
  ResultCacheColumnValuesRequest,
  ResultCacheColumnValuesResponse,
} from '../../../../types/queryExecution';

/**
 * Bounded batch fetch of FULL (untruncated) column values across a row range
 * of a cached result set. Used by windowed map/peek surfaces (spatial T11
 * peek, T13 QE Map view) that would otherwise decode truncated preview hex
 * into garbage geometry.
 *
 * Never throws — an IPC failure (dropped channel, disposed window, etc.)
 * resolves to an empty response so callers can treat "no data" and "error"
 * the same way (fail open, render nothing rather than crash).
 */
export async function fetchFullColumnValues(
  request: ResultCacheColumnValuesRequest
): Promise<ResultCacheColumnValuesResponse> {
  try {
    return await window.electronAPI!.resultCache.getColumnValues(request);
  } catch {
    return {
      values: [],
      rowsReturned: 0,
      byteBudgetExceeded: false,
      generation: request.expectedGeneration,
    };
  }
}
